import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map } from 'rxjs/operators';
import * as baseSiteActions from '../actions/site-context.actions';
import { SiteContextGatewayService } from '../gateway/site-context.gateway';

@Injectable({
  providedIn: 'any',
})
export class BaseSiteEffects {
  private actions$ = inject(Actions);
  private siteContextGatewayService = inject(SiteContextGatewayService);

  loadBaseSites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(baseSiteActions.loadBaseSites),
      exhaustMap((action) =>
        this.siteContextGatewayService.getBaseSites('FULL').pipe(
          map((response) =>
            baseSiteActions.loadBaseSitesSuccess({
              baseSites: response.baseSites,
              isInSmartEdit: action.isInSmartEdit,
            }),
          ),
        ),
      ),
    ),
  );
}
